export default [
  {
    section: "Acesso",
    items: [
      {
        slug: "acesso-login-departamento",
        title: "Login e departamento",
        description:
          "Como entrar no OS-m Admin e escolher o departamento de trabalho.",
        routeName: "app.manuais.acessoLoginDepartamento",
      },
    ],
  },
  {
    section: "OS-m",
    items: [
      {
        slug: "osm-listagem-exibicao",
        title: "Listagem e exibição",
        description: "Como listar, filtrar e abrir uma Ordem de Serviço.",
        routeName: "app.manuais.osmListagemExibicao",
      },
      {
        slug: "osm-emissao-nova",
        title: "Emissão: Nova",
        description: "Como emitir uma OS vinculada a um cadastro.",
        routeName: "app.manuais.osmEmissaoNova",
      },
      {
        slug: "osm-emissao-avulsa",
        title: "Emissão: Nova avulsa",
        description: "Como emitir uma OS avulsa (sem cadastro).",
        routeName: "app.manuais.osmEmissaoAvulsa",
      },
      {
        slug: "osm-emissao-massa",
        title: "Emissão: Novos em massa",
        description: "Como emitir várias OS para um grupo de fiscais.",
        routeName: "app.manuais.osmEmissaoMassa",
      },
      {
        slug: "osm-acao-editar",
        title: "Ação: Editar",
        description:
          "Como alterar fiscal, analista, situação e protocolo da OS.",
        routeName: "app.manuais.osmAcaoEditar",
      },
      {
        slug: "osm-acao-manutencao",
        title: "Ação: Manutenção",
        description:
          "Como alterar assunto, responsáveis, situação e agendamento (manutenção).",
        routeName: "app.manuais.osmAcaoManutencao",
      },
      {
        slug: "osm-acao-cancelar",
        title: "Ação: Cancelar",
        description: "Como cancelar uma OS e informar o motivo.",
        routeName: "app.manuais.osmAcaoCancelar",
      },
      {
        slug: "osm-acao-editar-areas",
        title: "Ação: Editar áreas",
        description: "Como adicionar, editar ou remover áreas da OS.",
        routeName: "app.manuais.osmAcaoEditarAreas",
      },
      {
        slug: "osm-solicitacoes-prazo",
        title: "Solicitações de prazo",
        description:
          "Como listar, visualizar, autorizar ou recusar solicitações de prazo.",
        routeName: "app.manuais.osmSolicitacoesPrazo",
      },
      {
        slug: "osm-outros-dept-listagem",
        title: "Outros departamentos: Listagem e exibição",
        description:
          "Como listar e abrir OS-m de outros departamentos.",
        routeName: "app.manuais.osmOutrosDeptListagem",
      },
      {
        slug: "osm-outros-dept-adicao",
        title: "Outros departamentos: Adição",
        description:
          "Como criar uma OS-m informativa para outro departamento.",
        routeName: "app.manuais.osmOutrosDeptAdicao",
      },
    ],
  },
  {
    section: "Análises",
    items: [
      {
        slug: "analises-minhas-listagem",
        title: "Minhas análises: Listagem e exibição",
        description:
          "Como listar e abrir as análises atribuídas a você.",
        routeName: "app.manuais.analisesMinhasListagem",
      },
      {
        slug: "analises-minhas-atendimento",
        title: "Minhas análises: Atendimento",
        description:
          "Como concluir, solicitar reanálise ou reabrir a OS-m.",
        routeName: "app.manuais.analisesMinhasAtendimento",
      },
      {
        slug: "analises-todas-listagem",
        title: "Todas as análises: Listagem e exibição",
        description:
          "Como listar e abrir análises de todo o departamento.",
        routeName: "app.manuais.analisesTodasListagem",
      },
    ],
  },
  {
    section: "Doc",
    items: [
      {
        slug: "doc-listagem-exibicao",
        title: "Listagem e exibição",
        description: "Como listar, filtrar e abrir um documento de fiscalização.",
        routeName: "app.manuais.docListagemExibicao",
      },
      {
        slug: "doc-emissao",
        title: "Emissão",
        description:
          "Emissão completa: tipo, modelo, informações, irregularidades, comentário, textos e confirmar.",
        routeName: "app.manuais.docEmissao",
      },
      {
        slug: "doc-acao-editar-rascunho",
        title: "Ação: Editar rascunho",
        description: "Como editar um documento ainda em rascunho.",
        routeName: "app.manuais.docAcaoEditarRascunho",
      },
      {
        slug: "doc-acao-revisao",
        title: "Ação: Solicitar revisão e Revisar",
        description: "Como solicitar revisão e revisar um documento.",
        routeName: "app.manuais.docAcaoRevisao",
      },
      {
        slug: "doc-acao-cancelar",
        title: "Ação: Cancelar",
        description: "Como cancelar um documento e informar o motivo.",
        routeName: "app.manuais.docAcaoCancelar",
      },
      {
        slug: "doc-acao-ciencia",
        title: "Ação: Ciência",
        description: "Como registrar ciência em um documento.",
        routeName: "app.manuais.docAcaoCiencia",
      },
      {
        slug: "doc-acao-comentar",
        title: "Ação: Comentar",
        description: "Como adicionar comentário, situação e anexos ao documento.",
        routeName: "app.manuais.docAcaoComentar",
      },
      {
        slug: "doc-acao-prazo-regularizar",
        title: "Ação: Prazo Regularizar",
        description: "Como alterar o prazo para regularização do documento.",
        routeName: "app.manuais.docAcaoPrazoRegularizar",
      },
      {
        slug: "doc-acao-verificar",
        title: "Ação: Verificar",
        description: "Como abrir a verificação do documento via OS-m.",
        routeName: "app.manuais.docAcaoVerificar",
      },
      {
        slug: "doc-acao-manutencao",
        title: "Ação: Manutenção",
        description: "Como alterar campos do documento em manutenção.",
        routeName: "app.manuais.docAcaoManutencao",
      },
      {
        slug: "doc-implantar",
        title: "Implantar",
        description: "Como listar documentos para implantar e concluir a implantação.",
        routeName: "app.manuais.docImplantar",
      },
      {
        slug: "doc-implantados",
        title: "Implantados",
        description: "Como listar e abrir documentos já implantados.",
        routeName: "app.manuais.docImplantados",
      },
      {
        slug: "doc-comentarios",
        title: "Comentários",
        description: "Como listar comentários de documentos e abrir o documento.",
        routeName: "app.manuais.docComentarios",
      },
      {
        slug: "doc-detalhados",
        title: "Detalhados",
        description: "Como consultar a listagem detalhada de documentos.",
        routeName: "app.manuais.docDetalhados",
      },
      {
        slug: "doc-publicacoes-listagem",
        title: "Publicações: Listagem e exibição",
        description: "Como listar e abrir publicações de documentos.",
        routeName: "app.manuais.docPublicacoesListagem",
      },
      {
        slug: "doc-publicacoes-nova",
        title: "Publicações: Nova e editar",
        description: "Como criar e editar uma publicação de documentos.",
        routeName: "app.manuais.docPublicacoesNova",
      },
      {
        slug: "doc-publicacoes-acoes",
        title: "Publicações: Ações",
        description:
          "Como vincular, desvincular, encerrar ou cancelar uma publicação.",
        routeName: "app.manuais.docPublicacoesAcoes",
      },
    ],
  },
  {
    section: "Consultas",
    items: [
      {
        slug: "consultas-cadastros-listagem",
        title: "Cadastros: Listagem e exibição",
        description:
          "Como listar, filtrar e abrir um cadastro em Consultas.",
        routeName: "app.manuais.consultasCadastrosListagem",
      },
      {
        slug: "consultas-alvaras-vencer",
        title: "Alvarás à vencer",
        description:
          "Como consultar cadastros com alvará próximo do vencimento.",
        routeName: "app.manuais.consultasAlvarasVencer",
      },
      {
        slug: "consultas-docs-geral",
        title: "Documentos: Geral",
        description:
          "Como consultar documentos de todos os departamentos.",
        routeName: "app.manuais.consultasDocsGeral",
      },
      {
        slug: "consultas-docs-por-irregularidade",
        title: "Documentos: Por irregularidade",
        description:
          "Como consultar documentos filtrando por irregularidade.",
        routeName: "app.manuais.consultasDocsPorIrregularidade",
      },
      {
        slug: "consultas-pagamentos-listagem",
        title: "Pagamentos: Listagem e exibição",
        description: "Como listar e abrir pagamentos em Consultas.",
        routeName: "app.manuais.consultasPagamentosListagem",
      },
      {
        slug: "consultas-fiscais-mapa",
        title: "Fiscais no mapa",
        description:
          "Como ver a localização dos fiscais e abrir o histórico.",
        routeName: "app.manuais.consultasFiscaisMapa",
      },
    ],
  },
  {
    section: "Produtividade",
    items: [
      {
        slug: "produtividade-geral-listagem",
        title: "Geral: Listagem e exibição",
        description:
          "Como listar períodos de produtividade e abrir o resumo geral.",
        routeName: "app.manuais.produtividadeGeralListagem",
      },
      {
        slug: "produtividade-resumo-exibicao",
        title: "Resumo do fiscal",
        description:
          "Como abrir o resumo de um fiscal e consultar as pontuações.",
        routeName: "app.manuais.produtividadeResumoExibicao",
      },
      {
        slug: "produtividade-resumo-acoes",
        title: "Resumo: Ações",
        description:
          "Como incluir serviços extras, pontos avulso, falta e afastamentos.",
        routeName: "app.manuais.produtividadeResumoAcoes",
      },
    ],
  },
  {
    section: "Indicadores",
    items: [
      {
        slug: "indicadores-analises",
        title: "Análises",
        description:
          "Como abrir os relatórios de indicadores de análises e filtrar resultados.",
        routeName: "app.manuais.indicadoresAnalises",
      },
      {
        slug: "indicadores-osm",
        title: "OS-m",
        description:
          "Como consultar indicadores de OS-m (tabelas e mapas).",
        routeName: "app.manuais.indicadoresOsm",
      },
      {
        slug: "indicadores-documentos",
        title: "Documentos",
        description:
          "Como consultar indicadores de documentos (tabelas e mapas).",
        routeName: "app.manuais.indicadoresDocumentos",
      },
      {
        slug: "indicadores-produtividade",
        title: "Produtividade",
        description:
          "Como consultar indicadores de média geral e pontuação por fiscal.",
        routeName: "app.manuais.indicadoresProdutividade",
      },
    ],
  },
  {
    section: "Configurações",
    items: [
      {
        slug: "config-modelos-doc-listagem",
        title: "Modelos de Documento: Listagem",
        description:
          "Como listar, filtrar e abrir modelos de documento.",
        routeName: "app.manuais.configModelosDocListagem",
      },
      {
        slug: "config-modelos-doc-wizard",
        title: "Modelos de Documento: Criação e edição",
        description:
          "Como criar ou editar um modelo no assistente de 9 passos.",
        routeName: "app.manuais.configModelosDocWizard",
      },
      {
        slug: "config-usuarios-listagem",
        title: "Usuários: Listagem e exibição",
        description:
          "Como listar usuários e abrir a ficha de exibição.",
        routeName: "app.manuais.configUsuariosListagem",
      },
      {
        slug: "config-usuarios-editar",
        title: "Usuários: Editar e afastamentos",
        description:
          "Como editar um usuário e gerenciar afastamentos.",
        routeName: "app.manuais.configUsuariosEditar",
      },
      {
        slug: "config-ausentes",
        title: "Ausentes",
        description:
          "Como listar e cadastrar substituições de usuários ausentes.",
        routeName: "app.manuais.configAusentes",
      },
      {
        slug: "config-usuario-grupos",
        title: "Grupos de usuários",
        description:
          "Como listar e cadastrar grupos de usuários.",
        routeName: "app.manuais.configUsuarioGrupos",
      },
      {
        slug: "config-perfis",
        title: "Perfis",
        description:
          "Como listar e configurar perfis e permissões.",
        routeName: "app.manuais.configPerfis",
      },
      {
        slug: "config-assuntos",
        title: "OS-m: Assuntos",
        description:
          "Como listar e configurar assuntos de OS-m.",
        routeName: "app.manuais.configAssuntos",
      },
      {
        slug: "config-formularios",
        title: "OS-m: Formulários",
        description:
          "Como montar o checklist: grupos, perguntas, mínimo de fotos, condições e referência.",
        routeName: "app.manuais.configFormularios",
      },
      {
        slug: "config-produtividade-params",
        title: "Parâm. de Produtividade",
        description:
          "Como configurar os parâmetros de produtividade.",
        routeName: "app.manuais.configProdutividadeParams",
      },
      {
        slug: "config-cadastros-restritos",
        title: "Cadastros restritos",
        description:
          "Como listar e cadastrar restrições de cadastro.",
        routeName: "app.manuais.configCadastrosRestritos",
      },
      {
        slug: "config-legislacoes",
        title: "Legislações",
        description:
          "Como listar, criar e editar legislações com anexo.",
        routeName: "app.manuais.configLegislacoes",
      },
      {
        slug: "config-logs-integracao",
        title: "Logs de integração",
        description:
          "Como consultar logs de jobs e tentar novamente.",
        routeName: "app.manuais.configLogsIntegracao",
      },
    ],
  },
  {
    section: "Mensagens",
    items: [
      {
        slug: "mensagens-recebidas",
        title: "Recebidas",
        description: "Como ler, responder, arquivar e restaurar mensagens recebidas.",
        routeName: "app.manuais.mensagensRecebidas",
      },
      {
        slug: "mensagens-enviadas",
        title: "Enviadas",
        description: "Como consultar, arquivar e restaurar mensagens enviadas.",
        routeName: "app.manuais.mensagensEnviadas",
      },
      {
        slug: "mensagens-nova",
        title: "Nova mensagem",
        description: "Como enviar uma mensagem para um destinatário.",
        routeName: "app.manuais.mensagensNova",
      },
      {
        slug: "mensagens-comunicado",
        title: "Comunicado interno",
        description: "Como enviar um comunicado para os usuários internos.",
        routeName: "app.manuais.mensagensComunicado",
      },
    ],
  },
]
